import {
  ENVS,
  getApigeeUrl,
  getEnv,
  isGovPartition,
} from "@adsk/acs-sc-web-platform-api";

type EnvConfig = {
  ASSET_ACTIVITY_LOG_START_DATE_STRING: string;
  ASSETS_BACKEND: string;
  CLASSIFICATIONS_BACKEND: string;
  FORM_TEMPLATES_BACKEND: string;
  HQ: string;
  LAUNCH_DARKLY_CLIENT_ID: string;
  LOCATIONS_BACKEND: string;
  PUBNUB: string;
};

const qa: EnvConfig = {
  ASSET_ACTIVITY_LOG_START_DATE_STRING: "2021-06-30T00:00:00Z",
  ASSETS_BACKEND: `${getApigeeUrl()}/construction/assets-qa`,
  CLASSIFICATIONS_BACKEND: `${getApigeeUrl()}/construction/classifications-qa`,
  FORM_TEMPLATES_BACKEND: `${getApigeeUrl()}/construction/forms-qa`,
  HQ: `${getApigeeUrl()}/bim360-qa/admin`,
  LAUNCH_DARKLY_CLIENT_ID: "5fad8b1168f61609d824b511",
  LOCATIONS_BACKEND: `${getApigeeUrl()}/construction/locations-qa`,
  PUBNUB: "autodesk.pubnubapi.com",
};

const staging: EnvConfig = {
  ASSET_ACTIVITY_LOG_START_DATE_STRING: "2021-06-30T00:00:00Z",
  ASSETS_BACKEND: `${getApigeeUrl()}/construction/assets`,
  CLASSIFICATIONS_BACKEND: `${getApigeeUrl()}/construction/classifications`,
  FORM_TEMPLATES_BACKEND: `${getApigeeUrl()}/construction/forms`,
  HQ: `${getApigeeUrl()}/bim360/admin`,
  LAUNCH_DARKLY_CLIENT_ID: "5fad8b10c6f1c809d946c5c6",
  LOCATIONS_BACKEND: `${getApigeeUrl()}/construction/locations`,
  PUBNUB: "autodesk.pubnubapi.com",
};

const prod: EnvConfig = {
  ASSET_ACTIVITY_LOG_START_DATE_STRING: "2021-06-30T00:00:00Z",
  ASSETS_BACKEND: `${getApigeeUrl()}/construction/assets`,
  CLASSIFICATIONS_BACKEND: `${getApigeeUrl()}/construction/classifications`,
  FORM_TEMPLATES_BACKEND: `${getApigeeUrl()}/construction/forms`,
  HQ: `${getApigeeUrl()}/bim360/admin`,
  LAUNCH_DARKLY_CLIENT_ID: "5fad8b0fbb17700a0424078b",
  LOCATIONS_BACKEND: `${getApigeeUrl()}/construction/locations`,
  PUBNUB: "autodesk.pubnubapi.com",
};

const ENV_CONFIGS: Record<(typeof ENVS)[keyof typeof ENVS], EnvConfig> = {
  [ENVS.QA]: qa,
  [ENVS.STAGING]: staging,
  [ENVS.PRODUCTION]: prod,
};

const GOVCLOUD_LAUNCH_DARKLY_CLIENT_IDS: Partial<
  Record<(typeof ENVS)[keyof typeof ENVS], string>
> = {
  [ENVS.STAGING]: "6aa41bab10a3d90bfba69157",
  [ENVS.PRODUCTION]: "6aa41bac3ac4680bf6f05d08",
};

export const getEnvValue = (key: keyof EnvConfig): string => {
  const env = getEnv();
  const config = ENV_CONFIGS[env];
  if (!config) {
    throw new Error(`Unsupported environment: ${env}`);
  }
  if (key === "LAUNCH_DARKLY_CLIENT_ID" && isGovPartition()) {
    const govCloudClientId = GOVCLOUD_LAUNCH_DARKLY_CLIENT_IDS[env];
    if (govCloudClientId) {
      return govCloudClientId;
    }
  }
  return config[key];
};
